<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Adatbank</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
<div class="adatbank">

  <ion-card>
    <ion-card-header>
      <ion-card-title>Adatbank</ion-card-title>
      <ion-card-subtitle>
        Bármelyik tanulói vagy gondviselői adatra kereshetsz, szabadon választhatod a
        megjelenő oszlopokat, és az eredményt Excelbe viheted. A gyakori listákhoz
        használd a kész szűrőket. A keresés az <b>{{ evFelirat }}</b> adataira fut.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <!-- Kész szűrők -->
      <div class="sablonok">
        <ion-button *ngFor="let s of sablonok" size="small"
                    [fill]="aktivSablon === s.kulcs ? 'solid' : 'outline'"
                    (click)="sablonAlkalmaz(s)" [title]="s.leiras">
          {{ s.nev }}
        </ion-button>
      </div>

      <!-- Keresősor -->
      <div class="sor">
        <ion-searchbar placeholder="Keresés a megjelenített oszlopokban…" [(ngModel)]="szoveg"
                       [debounce]="250" (ionChange)="kereses()"></ion-searchbar>

        <ion-select label="Osztály" label-placement="stacked" interface="popover"
                    [(ngModel)]="osztaly" (ionChange)="kereses()">
          <ion-select-option value="">Mind</ion-select-option>
          <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">
            {{ o.osztaly }} ({{ o.tanev }})
          </ion-select-option>
        </ion-select>

        <ion-select label="Rendezés" label-placement="stacked" interface="popover"
                    [(ngModel)]="rendezes" (ionChange)="kereses()">
          <ion-select-option *ngFor="let m of osszesMezo" [value]="m.kulcs">{{ m.nev }}</ion-select-option>
        </ion-select>

        <ion-button size="small" fill="outline" (click)="mezoValasztoNyitva = !mezoValasztoNyitva">
          <ion-icon slot="start" name="options-outline"></ion-icon>
          Oszlopok ({{ valasztott.length }})
        </ion-button>
        <ion-button size="small" (click)="kereses()">
          <ion-icon slot="start" name="search-outline"></ion-icon>Keresés
        </ion-button>
        <ion-button size="small" fill="outline" color="success" (click)="export()"
                    [disabled]="!eredmeny?.talalat">
          <ion-icon slot="start" name="download-outline"></ion-icon>Excel
        </ion-button>
      </div>

      <!-- Oszlopválasztó -->
      <div class="mezovalaszto" *ngIf="mezoValasztoNyitva">
        <div class="valasztott-lista">
          <b>Megjelenő oszlopok (sorrendben):</b>
          <div class="valasztott-sor" *ngFor="let k of valasztott; let i = index">
            <span>{{ i + 1 }}. {{ mezoNev(k) }}</span>
            <ion-button size="small" fill="clear" (click)="mozgat(i, -1)" [disabled]="i === 0">
              <ion-icon slot="icon-only" name="chevron-up-outline"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" (click)="mozgat(i, 1)"
                        [disabled]="i === valasztott.length - 1">
              <ion-icon slot="icon-only" name="chevron-down-outline"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" color="danger" (click)="mezoValt(k, false)">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </div>
        </div>

        <div class="mezo-csoport" *ngFor="let cs of csoportok">
          <b>{{ cs.cim }}</b>
          <div class="mezo-pipak">
            <ion-checkbox *ngFor="let m of cs.mezok" labelPlacement="end" [checked]="vanMezo(m.kulcs)"
                          (ionChange)="mezoValt(m.kulcs, $event.detail.checked)">{{ m.nev }}</ion-checkbox>
          </div>
        </div>
      </div>

      <!-- Szűrők -->
      <div class="szurok">
        <div class="szuro-sor" *ngFor="let sz of szurok; let i = index">
          <ion-select label="Mező" label-placement="stacked" interface="popover" [(ngModel)]="sz.mezo">
            <ion-select-option *ngFor="let m of osszesMezo" [value]="m.kulcs">{{ m.nev }}</ion-select-option>
          </ion-select>
          <ion-select label="Feltétel" label-placement="stacked" interface="popover" [(ngModel)]="sz.operator">
            <ion-select-option *ngFor="let o of operatorok" [value]="o.kulcs">{{ o.nev }}</ion-select-option>
          </ion-select>
          <ion-input label="Érték" label-placement="stacked" [(ngModel)]="sz.ertek"
                     [disabled]="sz.operator === 'ures' || sz.operator === 'nem_ures'"></ion-input>
          <ion-button size="small" fill="clear" color="danger" (click)="torolSzuro(i)">
            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
          </ion-button>
        </div>
        <div class="szuro-gombok">
          <ion-button size="small" fill="outline" (click)="ujSzuro()">
            <ion-icon slot="start" name="add-outline"></ion-icon>Szűrő hozzáadása
          </ion-button>
          <ion-checkbox labelPlacement="end" [checked]="lezartakIs"
                        (ionChange)="lezartakIs = $event.detail.checked; kereses()">
            Lezárt jogviszonyúak is
          </ion-checkbox>
          <!-- Tanév: alapból az aktuális; a korábbi évek külön kérhetők. -->
          <ion-select style="min-width:190px" label="Tanév" labelPlacement="stacked" interface="popover"
                      [ngModel]="valasztottEv" (ngModelChange)="evValt($event)">
            <ion-select-option value="">Aktuális tanév<span *ngIf="tanev"> ({{tanev}}/{{tanev+1}})</span></ion-select-option>
            <ion-select-option *ngFor="let t of tanevek" [value]="t.id">{{ t.name || (t.id + '/' + (t.id + 1)) }}</ion-select-option>
            <ion-select-option value="mind">Minden tanév</ion-select-option>
          </ion-select>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Találatok -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        Találatok
        <ion-badge color="primary" *ngIf="eredmeny">{{ eredmeny.talalat }} db</ion-badge>
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div *ngIf="betoltes" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <div class="tabla-doboz" *ngIf="!betoltes && eredmeny">
        <table class="talalat-tabla">
          <thead>
            <tr>
              <th class="sorszam">#</th>
              <th *ngFor="let m of eredmeny.mezok">{{ m.nev }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sor of eredmeny.sorok; let i = index">
              <td class="sorszam">{{ i + 1 }}</td>
              <td *ngFor="let m of eredmeny.mezok">{{ sor[m.kulcs] }}</td>
            </tr>
          </tbody>
        </table>

        <div class="ures" *ngIf="!eredmeny.sorok?.length">
          Nincs a keresésnek megfelelő találat.
        </div>
        <ion-note color="medium" *ngIf="eredmeny.talalat >= limit">
          A lista {{ limit }} sornál elvágva – szűkíts a szűrőkkel, vagy emeld a korlátot.
        </ion-note>
      </div>
    </ion-card-content>
  </ion-card>
</div>

</ion-content>
